import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	INPUT: 'input[required]',
};

class InlineHelpMessage extends WebComponent {
	constructor(props) {
		super(props);
		const {} = props;
		this.state = {};
	}

	didMount() {
		const {
			activeClass,
		} = this.props;

		this.activeClass = activeClass;

		this.inputElement = this.element.querySelectorAll(fragments.INPUT);
		this.checkAllInputs();

		for (let i = 0; i < this.inputElement.length; i++) {
			this.inputElement[i].addEventListener('keyup', (e) => {
				this.checkAllInputs();
			});
		}

	}

	checkAllInputs = () => {
		let showOnlyOneMessage = true;
		for (let i = 0; i < this.inputElement.length; i++) {
			if(this.inputElement[i].value === '' && showOnlyOneMessage) {
				this.inputElement[i].parentElement.classList.add(this.activeClass);
				showOnlyOneMessage = false;
			} else {
				this.inputElement[i].parentElement.classList.remove(this.activeClass);
			}
		}
	}

}

InlineHelpMessage.defaultProps = {
	activeClass: 'form-control--inline-message',
}

export default InlineHelpMessage;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Form/InlineHelpMessage.js